export function getUserFromLocalStorage() {
    let infoFromLocalSt = JSON.parse(localStorage.getItem("user"))
    if(!infoFromLocalSt) {
        return null
    }
    return infoFromLocalSt

}